import * as React from 'react'
import { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'hooks/use-redux'
import type { Group } from 'types/group'
import { alterTrackGroups } from '@disco/state-management/actions/ExplorerActions'
import { getGroupsWithNesting } from '@disco/state-management/selectors/groups'
import { makeGetShortlistsSelectedItems } from '@disco/state-management/selectors/selection'
import AddToChannelModal from 'components/common/custom-libraries/add-to-channel'
import DocumentHeadTags from 'components/document-head-tags'
import type { Track } from 'types/track'

const AddToChannel = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const getShortlistsSelectedItems = useMemo(
    () => makeGetShortlistsSelectedItems(),
    [],
  )

  const groups = useSelector(getGroupsWithNesting)
  const selectedItems = useSelector(state =>
    getShortlistsSelectedItems(state).filter(
      (track: Track) => !track.outside_your_territories,
    ),
  )

  const onClose = () => {
    navigate('/')
  }

  const onAddToGroup = (groupsToAdd: any[]) => {
    const existingGroups = groupsToAdd
      .filter(groupToAdd => !groupToAdd.created)
      .map(groupToAdd => {
        return groups.find((group: Group) => group.id === groupToAdd.value)
      })

    if (existingGroups.length) {
      dispatch(alterTrackGroups(selectedItems, existingGroups))
    }

    onClose()
  }

  return (
    <div>
      <DocumentHeadTags title="Add to channel | DISCO" />
      <AddToChannelModal
        groups={groups}
        onSubmit={onAddToGroup}
        onClose={onClose}
      />
    </div>
  )
}

export default AddToChannel
